import {
	SET_SUPPLIERS,
	SET_SUPPLIER,
	CLEAR_SUPPLIERS,
	CLEAR_SUPPLIER,
	ADD_SUPPLIER,
	UPDATE_SUPPLIER,
	REMOVE_SUPPLIER,
} from './actionTypes';

export const supplier = (state = {}, action) => {
	switch (action.type) {
		case SET_SUPPLIER:
			return action.payload;
		case UPDATE_SUPPLIER:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SUPPLIER:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_SUPPLIERS:
			return action.payload;
		case ADD_SUPPLIER:
			return [...state, action.payload];
		case UPDATE_SUPPLIER:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_SUPPLIER:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_SUPPLIERS:
			return [];
		default:
			return state;
	}
};
